import { render, staticRenderFns } from "./Laptop.vue?vue&type=template&id=658eb79a&%3ApageData=pageData&"
import script from "./Laptop.vue?vue&type=script&lang=js&"
export * from "./Laptop.vue?vue&type=script&lang=js&"
import style0 from "../assets/EFI.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports